import React, { ReactNode } from 'react';
import { SnackbarProvider, useSnackbar, VariantType, SnackbarKey } from 'notistack';
import colorConfigs from '../../../configs/colorConfigs';
import { typo } from '../../../assets/fonts/font';

let useSnackbarRef: any;
export const SnackbarUtilsConfigurator: React.FC = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

interface SnackbarComponentProps {
  children: ReactNode;
}

const SnackbarComponent: React.FC<SnackbarComponentProps> = ({ children }) => (
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
  >
    <SnackbarUtilsConfigurator />
    {children}
  </SnackbarProvider>
);

export const toast = {
  success(msg: string) {
    this.toast(msg, 'success');
  },
  error(msg: string) {
    this.toast(msg, 'error');
  },
  toast(msg: string, variant: VariantType = 'default') {
    useSnackbarRef.enqueueSnackbar(msg, {
      variant,
      content: (key: SnackbarKey) => (
        <div
          key={key}
          style={{
            backgroundColor: variant === 'success' ? colorConfigs.primary : variant === 'error' ? colorConfigs.errorBg : '',...typo.bodyContent,
            color: variant === 'success' ? colorConfigs.secondary : variant === 'error' ? colorConfigs.secondary : '',
            padding: '16px',
            borderRadius: '4px',
          }}
        >
          {msg}
        </div>
      ),
    });
  },
};

export default SnackbarComponent;
